import type { SxProps } from "@mui/material"

import { NAV_PANEL_BG } from "@constants/colors"

const container: SxProps = {
  minHeight: "100vh",
  height: "100%",
  background: NAV_PANEL_BG
}

const bottomArea: SxProps = {
  alignItems: "center",
  flexGrow: 1,
  justifyContent: "flex-end",
  pb: "1rem"
}

export default { container, bottomArea }
